import { IQuoteRespSchema } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import { SalesforceIcon } from '@monetize/ui/icons';
import { FunctionComponent as FC } from 'react';
import { useParams } from 'react-router';
import { useGetCrmConfiguration } from '../../api/settingsService';
import { shortenID } from '../../utils';
import { MBox, MButton, MIcon, MTag, MText } from '../Monetize';
import { OpportunityModal } from '../Opportunities/OpportunityModal';

export interface QuoteBasicOpportunityDataTypes {
  isOpen: boolean;
  quote?: Maybe<IQuoteRespSchema>;
  onOpen: () => void;
  onClose: () => void;
  /** Fetch quote */
  loadData?: Maybe<() => void>;
}

interface QuoteBasicOpportunityProps {
  isOpen: boolean;
  isDisabled?: boolean;
  quote?: Maybe<IQuoteRespSchema>;
  onOpen: () => void;
  onClose: (skipNavigate?: boolean) => void;
  loadData?: Maybe<() => void>;
}

export const QuoteBasicOpportunity: FC<QuoteBasicOpportunityProps> = ({
  isOpen,
  isDisabled,
  quote,
  onOpen,
  onClose,
  loadData,
}: QuoteBasicOpportunityProps) => {
  const params = useParams();
  const { opportunity } = quote || {};
  const opportunityId = opportunity?.id || params?.opportunityId || '';

  const { data: crmConnections } = useGetCrmConfiguration({
    enabled: isOpen && !!opportunityId,
  });

  // Don't show if an opportunity does not exist (should never happen)
  if (!quote || !opportunity) {
    return null;
  }

  return (
    <MBox position="relative" display="flex" alignItems="center">
      {quote.id === opportunity?.primaryQuoteId && (
        <MTag variant="blue" fontSize="xs" mr="1" px="1">
          Primary Quote
        </MTag>
      )}
      <MButton
        variant="link"
        display="flex"
        alignItems="center"
        onClick={onOpen}
        w="initial"
      >
        {opportunity?.id && (
          <MText color="inherit" title={opportunity.id}>
            {shortenID(opportunity?.id, 3, 5)}
          </MText>
        )}
        {crmConnections?.salesforce && opportunity?.customId && (
          <MIcon as={SalesforceIcon} w={7} ml="2" />
        )}
      </MButton>

      <OpportunityModal
        isOpen={isOpen}
        isDisabled={isDisabled}
        onClose={() => {
          loadData && loadData();
          onClose();
        }}
        opportunityId={opportunity.id}
      />
    </MBox>
  );
};

export default QuoteBasicOpportunity;
